<template>
<svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
<g><path d="M500,990C229.8,990,10,770.1,10,500C10,229.8,229.8,10,500,10c270.2,0,490,219.8,490,490C990,770.1,770.2,990,500,990z M500,97.7C278.2,97.7,97.7,278.1,97.7,500c0,221.9,180.5,402.3,402.3,402.3c221.8,0,402.3-180.5,402.3-402.3C902.3,278.1,721.8,97.7,500,97.7z"/><path d="M500,305.5c-28.8,0-52.2-23.4-52.2-52.2c0-28.8,23.4-52.2,52.2-52.2s52.2,23.4,52.2,52.2C552.2,282.1,528.9,305.5,500,305.5L500,305.5z"/><path d="M500,808.1c-24.2,0-43.8-19.6-43.8-43.8V440.5c0-24.2,19.6-43.8,43.8-43.8c24.2,0,43.8,19.6,43.8,43.8v323.8C543.8,788.5,524.2,808.1,500,808.1z"/></g>
</svg>
</template>

<script>
export default {
  name: 'InfoIcon'
}
</script>

<style scoped>
  .svg-icon {
    width: 100%;
    height: 100%;
    fill: #c2d1d9;
  }
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/InfoIcon.vue